import Vue from 'vue'
import CreateAPI from 'vue-create-api'
import UserLogin from './UserLogin'

Vue.use(CreateAPI)

Vue.createAPI(UserLogin, true)

let instance = null

export default {
  show() {
    instance = UserLogin.$create({
      $props: {}
    }).show()
  },
  hide() {
    if (instance) {
      instance.hide()
    }
  }
}
